import { render, staticRenderFns } from "./ShowQuestion.vue?vue&type=template&id=6fb04e30&"
import script from "./ShowQuestion.vue?vue&type=script&lang=js&"
export * from "./ShowQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports